import { Observable } from 'rxjs';

import { Category, ResultPage } from '@mirage-projects/cw-models';

/**
 * Abstract service definition to manage the categories endpoints
 */
export abstract class CategoryService {
    /**
     * Get the category by id
     * @param id Category id
     */
    abstract getCategory(id: number): Observable<Category>;

    /**
     * Get the list of categories
     */
    abstract getCategoryList(): Observable<ResultPage<Category>>;
}
